import { createFileRoute } from "@tanstack/react-router";
import Tracker360 from "@/components/Tracker360";
import { tracker360Faq } from "@/lib/tracker360-content";

const URL = "https://thequantumminds.in/tracker-360";
const TITLE = "Tracker 360 – Smart Study Planner & Backlog Timetable | The Quantum Minds";
const DESCRIPTION =
  "Tracker 360 is a smart study planner that turns lecture backlogs, syllabus targets and study deadlines into a personalized timetable with daily pacing, revision planning and progress tracking.";

export const Route = createFileRoute("/tracker-360")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:type", content: "website" },
      { property: "og:url", content: URL },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: TITLE },
      { name: "twitter:description", content: DESCRIPTION },
    ],
    links: [{ rel: "canonical", href: URL }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "SoftwareApplication",
              name: "Tracker 360",
              applicationCategory: "EducationalApplication",
              operatingSystem: "Web",
              url: URL,
              description: DESCRIPTION,
              publisher: { "@type": "Organization", name: "The Quantum Minds", url: "https://thequantumminds.in" },
            },
            {
              "@type": "BreadcrumbList",
              itemListElement: [
                { "@type": "ListItem", position: 1, name: "Home", item: "https://thequantumminds.in/" },
                { "@type": "ListItem", position: 2, name: "Tracker 360", item: URL },
              ],
            },
            {
              "@type": "FAQPage",
              mainEntity: tracker360Faq.map((f) => ({
                "@type": "Question",
                name: f.q,
                acceptedAnswer: { "@type": "Answer", text: f.a },
              })),
            },
          ],
        }),
      },
    ],
  }),
  component: Tracker360Page,
});

function Tracker360Page() {
  return (
    <div className="py-4">
      <Tracker360 />
    </div>
  );
}
